import { emptyProps } from 'element-plus/es/components/empty/src/empty.mjs'
import { EMPTY_IMAGE } from '~/config/empty'

// 全局替换 Element Plus 默认蓝色空状态图标（ElTable / ElEmpty 等）
;(emptyProps.image as { default: string }).default = EMPTY_IMAGE

export default defineNuxtPlugin({
  name: 'element-empty',
  enforce: 'pre',
  setup() {},
})
